import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { officialspublicurl } from '../../../apis/urls'
import { decode } from "html-entities";

const CoachList = () => {

    const[result, setResult] = useState([])

    const { id } = useParams();


    useEffect( ()=>{

        coachListing()

    },[])


    const coachListing = () =>{

        //let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: officialspublicurl+'/'+id+'?page='+0+'&size='+10,

            timeout: 1000000,

            // headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data.items);
            console.log(response.data.data.items)

           
          }).catch((error) =>{
            
            console.log('error',error)
            

          });


    }


    let sl =1;
  return (
    <div>
      <aside class="right-side areas">
        <div class="content-area dash-contentss">
          <div class="page-title-wrpr">
            <div class="page-title-left-column">
              <i class="icon-library1"></i>
              <h2 class="page-title"> Coach List</h2>
            </div>
          </div>

          <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item"><Link to="/school_list">School List</Link></li>
                <li class="breadcrumb-item active" aria-current="page">Coaches</li>
              </ol>
            </nav>

            <div class="faculty-list-wrpr list-wrpr"> 
                {
                    result?.map((item,index)=>{

                        //  item.coachpayments.map((items,index)=>{
                            
                        

                            return(
                                <div class="list faculty">
                               
                                        

                                        <div class="row">
                                        <div class="col-md-1">
                                                <div class="faculty-user">Sl No.
                                                    <span class="desig">{sl++}</span>
                                                </div>     
                                                </div>
                                            

                                                <div class="col-md-4">
                                                <div class="faculty-user">Name
                                                    <span class="desig">{decode(item.firstname+' '+item.lastname)}</span>
                                                </div>     
                                                </div>

                                                
                                                <div class="col-md-3">
                                                <div class="faculty-user">Email
                                                    <span style={{cursor: 'pointer'}}  onClick={() => window.location = 'mailto:'+item.email} class="desig">{item.email}</span>
                                                </div>     
                                                </div>
                                                
                                                <div class="col-md-2">
                                                <div class="faculty-user">Cell phone
                                            
                                                <span style={{cursor: 'pointer'}} class="desig">{item.cell_phone}</span>
                                                
                                                </div>     
                                                </div> 

                                                
                                                
                                            <div class="col-md-2">
                                                {/* <div class="list-action-wrpr text-right roundicons-text">
                                                    <Link  to={"/facultyview/"} title="View" ><i class="view icon-eye" style={{backgroundColor:'#eabb73'}} ></i ><span>View</span></Link>
                                                </div> */}
                                            </div>
                                        </div>   
                                        

                                </div>             
                            )
                        // })
                        
                    })


                }

                {
                    result.length === 0 ?
                    (<div className="nodata">
                            <h2>Sorry! No Coach Found</h2>
                        </div>):null
                }
                
                
            </div>


        </div>
      </aside>
    </div>
  );
};

export default CoachList;